<template lang="pug">
	modal(v-if="linea", :max-width="400")
		.card.text-left
			.card-header
				span.fa.fa-puzzle-piece.mr-2
				| Colocación
				button.close(@click="cerrar") &times;
			.card-body.bg-light.text-center
				// TENEMOS 3 POSIBILIDADES DE COLOCACIÓN:
					- POR PROGRAMA
					- POR CONTENIDOS
					- POR INTÉRVALOS DE HORAS Y DÍAS MANUALES
				.alert.alert-success.text-left
					b
						span.fa.fa-puzzle-piece.mr-2
						| Tipo de colocación
					p
						| Debes definir el tipo de colocación que vas a emplear:
						ul
							li <b>Por programa:</b> Los originales siempre se colocarán dentro del programa seleccionado
							li <b>Por contenido:</b> Los originales siempre se colocación dentro de los contenidos seleccionados
							li <b>Manual:</b> Debes definir un intérvalo de días de la semana y horas para colocar los originales
				.form-group
					label Tipo de colocación
					br
					.btn-group
						button.btn(:class="(linea.tipoColocacion === 'programa') ? 'btn-primary' : ''", @click="setTipoColocacion('programa')") Programa
						button.btn(:class="(linea.tipoColocacion === 'contenido') ? 'btn-primary' : ''", @click="setTipoColocacion('contenido')") Contenido
						button.btn(:class="(linea.tipoColocacion === 'manual') ? 'btn-primary' : ''", @click="setTipoColocacion('manual')") Manual
			.card-body(v-if="linea.tipoColocacion === 'programa'")
				// Listado de programas
				.form-group
					label Selecciona un programa
					select.form-control(v-model="linea.programa_ID")
						option(:value="null") Selecciona
						option(
							v-for="programa in listadoProgramas"
							:key="programa.ID_programa"
							:value="programa.ID_programa"
						) {{ programa.nombre }}

</template>

<script>
export default {
	props: ['lineaContrato'],
	data () {
		return {
			linea: null
		}
	},
	created () {
		this.linea = this.lineaContrato
	},
	watch: {
		lineaContrato: function (newVal) {
			this.linea = newVal
		}
	},
	methods: {
		setTipoColocacion (tipo) {
			this.linea.tipoColocacion = tipo
			this.$forceUpdate()
		},

		actualizar () {
			this.$emit('update:linea-contrato', this.linea)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/radiacion/colocacion.vue